import template from './referrerComparison.html';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    referrerObj: '<',
  },
};
